import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';

interface IMuiButton {
  defaultProps?: ComponentsProps['MuiButton'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiButton'];
  variants?: ComponentsVariants['MuiButton'];
}

const MuiButtonConfig: IMuiButton = {
  variants: [
    {
      props: { variant: 'text' },
      style: {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
  ],
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 48,
      textTransform: 'none',
      '&.Mui-disabled': {
        backgroundColor: theme.palette.sixth.main,
        color: theme.palette.sixth.contrastText,
        borderColor: theme.palette.sixth.main,
      },
      '& .MuiLoadingButton-loadingIndicatorCenter': {
        top: '50%',
        transform: 'translate(-50%, -50%)',
      },
      '&.MuiButton-root': {
        boxShadow: 'none',
        '&.MuiButton-containedPrimary&:hover': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
        },
      },
    }),
  },
};

export default MuiButtonConfig;